/**
 * TODO: write documentation
 */
export default class KeyFigureContextRepositoryWrapper {
	/**
	 * Wrap a repository to automatically inject the cached keyFigures into the queries context.
	 * It is polymorphic with `Repository` to ease transition.
	 *
	 * @param {KeyFigureService} [keyFigureService] - Service used to get all the keyFigures
	 * @param {Repository} repository - Repository to wrap
	 */
	constructor({ keyFigureService, repository }) {
		this._keyFigureService = keyFigureService;
		this._repository = repository;
	}

	get(options) {
		return this._keyFigureService
			.getAllFromCacheAsMap()
			.then((keyFigures) =>
				this._repository.get(
					this._injectKeyFiguresInContext(keyFigures, options),
				),
			);
	}

	save(options) {
		return this._keyFigureService
			.getAllFromCacheAsMap()
			.then((keyFigures) =>
				this._repository.save(
					this._injectKeyFiguresInContext(keyFigures, options),
				),
			);
	}

	update(options) {
		return this._keyFigureService
			.getAllFromCacheAsMap()
			.then((keyFigures) =>
				this._repository.update(
					this._injectKeyFiguresInContext(keyFigures, options),
				),
			);
	}

	remove(options) {
		return this._keyFigureService
			.getAllFromCacheAsMap()
			.then((keyFigures) =>
				this._repository.remove(
					this._injectKeyFiguresInContext(keyFigures, options),
				),
			);
	}

	buildUrl(options) {
		return this._repository.buildUrl(options);
	}

	_injectKeyFiguresInContext(keyFigures, options = {}) {
		options.context ||= {};
		options.context.keyFigures ||= keyFigures;
		return options;
	}
}
